<!-- <nav class="navbar navbar-expand-md bg-primary navbar-dark nav-custom-style">
    <div class="container">
      <div class="row">
		<button *ngIf="isUserLoggedIn" data-toggle="collapse-side" data-target=".side-collapse" data-target-2=".side-collapse-container" type="button" class="navbar-toggler navbar-toggler-right d-block navbar-toggle pull-left"><span class="navbar-toggler-icon"></span></button>
        <div class="col-md-0">
		  <img src="http://223.31.219.47/CDN/FormBuilderACP/images/Sifylogo.png" width="100" />
		  <span *ngIf = "ulrAcp==1">{{ACPprojectName}}</span>
        </div>
      </div>
      <div *ngIf="isUserLoggedIn" class="collapse navbar-collapse text-center justify-content-end d-none d-md-block" id="navbar2SupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href="#"><i class="fa d-inline fa-lg fa-user-circle-o"></i>{{LoggedUserName}} </a>
          </li>
        </ul>
        <a class="btn navbar-btn ml-2 text-white btn-danger" (click)="userLogout()"> Logout</a>
      </div>
	  
	  <div *ngIf="routerPathloc != '' && ulrAcp==1 && IsACPUserLoggedIn" class="collapse navbar-collapse text-center justify-content-end d-none d-md-block loginDetails" id="navbar2SupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link" href="#"><i class="fa d-inline fa-lg fa-user-circle-o"></i>{{ACPLoggedUserName}} </a>
          </li>
        </ul>
        <a class="btn navbar-btn ml-2 text-white btn-danger" (click)="acpUserLogout()"> Logout</a>
      </div>
	  
	  <div class="text-center justify-content-end d-block d-md-none loginDetails" id="navbar2SupportedContent">
        <a class="btn navbar-btn ml-2 text-white btn-danger" (click)="userLogout()"> <i class="fa d-inline fa-lg fa-power-off" title="Logout"></i></a>
      </div>
    </div>
 </nav> -->


 <header class="header fixed-top clearfix" *ngIf="isUserLoggedIn">  
  <div class="brand"> 
    <a routerLink="/dashboard" class="logo"> <img src="assets/img/logo.png" alt="logo"><!-- <span *ngIf = "ulrAcp==1">{{ACPprojectName}}</span>  --></a>
    <button  data-toggle="collapse-side" data-target=".side-collapse" data-target-2=".side-collapse-container" type="button" class="sidebar-toggler">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </button> 
  </div>  
  <div class="userdropdown row align-items-center"> 
    <div class="dropdown show col">
      <a class="btn dropdown-toggle pull-right" href="#" role="button" id="profile" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="avatar"><img src="assets/img/avatar5.png" alt="userimage"></span>
        <span class="username d-none d-md-inline-block"><span>{{LoggedUserName}}</span></span>
      </a>  
      <!-- <div class="dropdown-menu dropdown-menu-right" aria-labelledby="profile">
        <span class="dropdown-item"><i class="fa fa-envelope"></i> rajamanickam.raju@sifycorp.com</span>
        <a class="dropdown-item" [routerLink]="['/user/achieve']"><i class="fa fa-user"></i> Profile</a>
        <a class="dropdown-item" [routerLink]="['/user/userSetting']"><i class="fa fa-cog"></i> Settings</a>
        <a class="dropdown-item" (click)="onUserSignOut()"><i class="fa fa-sign-out"></i> Sign out</a>
      </div> -->
    </div>  
    <a class="btn logout-btn col-auto" (click)="userLogout()"> <i class="fa d-inline fa-lg fa-power-off" title="Logout"></i></a>          
  </div> 
</header>
